module.exports = __webpack_public_path__ + "img/vip_transfer.2a6f0177.png";